import React, {Component} from 'react';
import {Button} from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';

export default class ContractFundingSearchFrameworkContract extends Component {
    constructor() {
        super();

        this.state = {
            id: "",
            article_id: "",
            framework_contracts: [{value: "", label: window.__js_general.all}],
            articles: [{value: "", label: window.__js_general.all}],
        };

        this.handleFrameworkContractChange = this.handleFrameworkContractChange.bind(this);
        this.handleFrameworkContractArticleChange = this.handleFrameworkContractArticleChange.bind(this);
        this.getFrameworkContracts = this.getFrameworkContracts.bind(this);
        this.getArticles = this.getArticles.bind(this);
    }

    componentWillMount() {
        this.setState({
            id: this.props.id === undefined ? "" : this.props.id,
            article_id: this.props.articleId
        }, () => {
            this.getFrameworkContracts();
            this.getArticles();
        });
    }

    getFrameworkContracts() {
        axios
            .get("/contracts/ajax/framework_contracts")
            .then((response) => {
                let items = [
                    {value: "", label: window.__js_general.all}
                ];
                for (let key in response.data) {
                    if (response.data.hasOwnProperty(key)) {
                        let item = response.data[key];

                        items.push({
                            value: item.id,
                            label: item.title
                        });
                    }
                }

                this.setState({framework_contracts: items});
            });
    }

    getArticles() {
        if (this.state.id !== "" && this.state.id !== undefined) {
            axios
                .get("/contracts/ajax/framework_contracts/" + this.state.id + "/articles")
                .then((response) => {
                    let items = [
                        {value: "", label: window.__js_general.all}
                    ];
                    for (let key in response.data) {
                        if (response.data.hasOwnProperty(key)) {
                            let item = response.data[key];

                            items.push({
                                value: item.id,
                                label: item.title
                            });
                        }
                    }

                    this.setState({articles: items});
                });
        } else {
            this.setState({
                article_id: "",
                articles: [{value: "", label: window.__js_general.all}],
            });
        }
    }

    handleFrameworkContractChange(e) {
        let framework_contract_id = 0;
        if (e != null)
            framework_contract_id = e.value;
        this.setState({
            id: framework_contract_id
        }, () => {
            this.getArticles();
        });
    }

    handleFrameworkContractArticleChange(e) {
        let framework_contract_article_id = 0;
        if (e != null)
            framework_contract_article_id = e.value;
        this.setState({article_id: framework_contract_article_id});
    }

    render() {
        return (
            <div>
                <div className="form-group">
                    <label htmlFor="framework_contract_id" className="col-md-4 control-label">
                        {window.__js_contracts.framework_contract}
                    </label>
                    <div className="col-md-8">
                        <Select name="framework_contract_id"
                                id="framework_contract_id"
                                clearable={false}
                                value={this.state.id}
                                options={this.state.framework_contracts}
                                onChange={this.handleFrameworkContractChange}>
                        </Select>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="framework_contract_article_id" className="col-md-4 control-label">
                        {window.__js_contracts.article}
                    </label>
                    <div className="col-md-8">
                        <Select name="framework_contract_article_id"
                                id="framework_contract_article_id"
                                clearable={false}
                                value={this.state.article_id}
                                options={this.state.articles}
                                onChange={this.handleFrameworkContractArticleChange}>
                        </Select>
                    </div>
                </div>
            </div>
        );
    }
}